import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/hit
// A hit occurs when a batter strikes the baseball into fair territory and reaches base without doing so via an error or a fielder's choice. There are four types of hits in baseball: singles, doubles, triples and home runs. All four are counted equally when deciphering batting average. If a player is thrown out attempting to take an extra base (e.g., turning a single into a double), that still counts as a hit.
const classifiesAsHit = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.Double.key:
        case PlateAppearanceResult.GroundRuleDouble.key:
        case PlateAppearanceResult.HomeRun.key:
        case PlateAppearanceResult.InsideTheParkHomeRun.key:
        case PlateAppearanceResult.Single.key:
        case PlateAppearanceResult.Triple.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsHit;